
import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";
import { DashboardLayout } from "@/components/layout/DashboardLayout";
import { UserTable } from "@/components/admin/users/UserTable";
import { toast } from "sonner";
import { handleResizeObserverError } from "@/utils/resizeObserverHandler";
import { useEffect } from "react";

const Users = () => {
  useEffect(() => {
    handleResizeObserverError();
  }, []);

  const { data: owners, isLoading, refetch } = useQuery({
    queryKey: ["owners"],
    queryFn: async () => {
      try {
        // Récupérer tous les profils
        const { data: profiles, error: profilesError } = await supabase
          .from("profiles")
          .select(`
            *,
            owner_data (
              company_name,
              business_type_id
            )
          `);

        if (profilesError) {
          console.error("Erreur lors de la récupération des profils:", profilesError);
          throw profilesError;
        }

        // Récupérer les abonnements séparément
        const { data: subscriptions, error: subsError } = await supabase
          .from('subscriptions')
          .select('*');

        if (subsError) {
          console.error("Erreur lors de la récupération des abonnements:", subsError);
          throw subsError;
        }

        console.log("Profils récupérés:", profiles);
        console.log("Abonnements récupérés:", subscriptions);

        // Combiner les données
        const enrichedProfiles = profiles.map(profile => {
          const userSubscription = subscriptions?.find(sub => sub.owner_id === profile.id);
          return {
            ...profile,
            subscription_plan: userSubscription?.plan || 'free',
            product_limit: userSubscription?.product_limit || 3
          };
        });

        console.log("Profils enrichis:", enrichedProfiles);
        
        return enrichedProfiles;
      } catch (error) {
        console.error("Erreur globale:", error);
        toast.error("Erreur lors de la récupération des données");
        return [];
      }
    },
  });

  const handleBlockUser = async (userId: string, isBlocked: boolean) => {
    const { error } = await supabase
      .from("profiles")
      .update({ is_blocked: isBlocked })
      .eq("id", userId);

    if (error) {
      toast.error("Erreur lors de la mise à jour du statut de l'utilisateur");
      return;
    }

    toast.success(
      `Utilisateur ${isBlocked ? "bloqué" : "débloqué"} avec succès`
    );
    refetch();
  };

  return (
    <DashboardLayout userType="admin">
      <div className="container mx-auto p-6">
        <h1 className="text-2xl font-bold mb-6">Gestion des utilisateurs</h1>
        <UserTable
          owners={owners || []}
          isLoading={isLoading}
          onBlockUser={handleBlockUser}
        />
      </div>
    </DashboardLayout>
  );
};

export default Users;
